/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { useLocation } from "react-router-dom";

const useOnLanding = () => {
  const location = useLocation();

  return location.pathname === "/";
};

export default useOnLanding;
